const colors = {
  pink: '#fc7bfb',
  purple: '#2e1c46',
}

export default {
  colors,
}



// WEBPACK FOOTER //
// ./src/theme.js